// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"353":"bbb18bfe4e039a0673ce","482":"c5d3fb8bb0ef7e0f009d","595":"34ecdd40ead7bdc70e78","897":"0e98ad8b0c9bd9282303"}[chunkId] + ".js";
};